<template>
    <rkm-row>
        <rkm-col cols="12">
            <rkm-form-radio-group
                :options="abrangenciaOptions"
                button-color="outline-primary"
                buttons
                class="abrangencia-radio"
                label="Abrangência"
                text-field="descricao"
                value-field="id"
                :checked="value.abrangencia"
                @input="onAbrangenciaChange"
            />
        </rkm-col>

        <rkm-col cols="12" v-if="value.abrangencia === enums.abrangencia.SELECIONADAS">
            <rkm-form-multiselect
                :options="options"
                label="Unidades/local de atendimento"
                optionTextSelecteds="unidade selecionada"
                :value="value.infraestruturas"
                @input="onInfraestruturasChange"
                optionNameKey="nome"
                value-field="id"
                :selectLimit="99"
                uniform-checkbox
            />
        </rkm-col>
    </rkm-row>
</template>

<script>
import abrangenciaEnum from '@/enums/cadastro/feriado/abrangencia'

export default {
    computed: {
        enums: () => ({ abrangencia: abrangenciaEnum }),
        abrangenciaOptions() {

            return [
                { id: abrangenciaEnum.TODAS, descricao: 'Todas as unidades/local de atendimento' },
                { id: abrangenciaEnum.SELECIONADAS, descricao: 'Unidades/local de atendimento selecionadas' },
            ]
        },
    },
    methods: {
        onAbrangenciaChange(abrangencia) {

            this.$emit('input', {
                ...this.value,
                abrangencia,
                infraestruturas: abrangencia === abrangenciaEnum.TODAS ? [] : this.value.infraestruturas,
            })
        },
        onInfraestruturasChange(infraestruturas) {

            this.$emit('input', { ...this.value, infraestruturas })
        },
    },
    props: {
        options: { type: Array, default: () => [] },
        value: { type: Object, required: true },
    },
}
</script>

<style scoped>
.abrangencia-radio >>> .btn-group {
    width: 100%;
}
.abrangencia-radio >>> .btn-group .btn {
    flex: 1 1 0;
    white-space: normal;
    word-break: break-word;
}
</style>
